import Langue from "../model/Langue";
/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:17/01/2021
 @Time:09:20
 **/
export default class LangueService{

    /**
     *
     * @type {LangueService}
     */
   static  #instance=null;


    /**
     *
     * @type {Langue[]}
     * @private
     */
    #langues=[];

    /**
     * LangueService active
     * @type {Langue}
     * @private
     */
    #activeLangue=null;

    /**
     * @description constructeur de service
     */
    constructor() {
        if(LangueService.#instance===null) {
             Begro.logInfo("Creation d'une instance singleton du service Langue Service");
             if (typeof window !== "undefined" && typeof jQuery !== "undefined") {
                Begro.logInfo("Langue module fonctionne en mode web - creation instance pour le web");
                this.#createWebInstance();
            } else {
                Begro.logError("Langue module ne fonctionne pas en mode web et il n'est pas implémenté!");
            }
        }
        return LangueService.#instance;
    }


    /**
     * Retourne Instance du langue service -singleton
     * @return {LangueService}
     */
    static getInstance() {
        if(this.#instance!=null)
        {
            Begro.logInfo("Langue service singleton existe et sera retourné ");
        }else{
            Begro.logInfo("Langue Service instance n'existe pas ! ");
            this.#instance= new LangueService();
        }
        return this.#instance;
    }



    get langues(){
        return this.#langues;
    }




    /**
     * set Active locale
     * @param {string} locale
     */
    setActiveLocale(locale)
    {
        for(let i  in this.#langues)
        {
            if(this.#langues[i].locale===locale){
                Begro.logInfo("Active Langue set successfully "+locale+"!")
                this.#activeLangue=this.#langues[i];
                break;
            }
        }
    }


    get activeLangue() {
        return this.#activeLangue;
    }
    

   #createWebInstance(){
       LangueService.#instance=this;
       if(typeof languages !== "undefined")
       {
           Begro.logInfo("les langues disponibles dans begro sont détecté depuis la page HTML : "+languages);
           this.#langues=Langue.createLanguesFromJsonArray(languages);
       }else{
           Begro.logWarning("les langues disponibles dans begro n'ont pas pu être détecté depuis la page HTML ");
       }
       if(typeof locale != "undefined")
       {
           Begro.logInfo("Langue Active détecté depuis la page HTML : "+locale);
           this.setActiveLocale(locale);
       }else{
           Begro.logInfo("La Langue n'a pas pu détecté depuis la page HTML ce qui cause des problèmes ");
       }
   }


}